import React, { useEffect, useState, useRef } from "react";
import { Row, Col} from "react-bootstrap";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import "./DragAndDrop.css";

const DragAndDrop = ({
  selectElements, selectedElements, setSelectedElements
}) => {
  const scrollToBottomRef = useRef(null);
  const [searchQuery, setSearchQuery] = useState(null);
  const [searchedOptions, setSearchedOptions] = useState(null);

  const handleCheckboxChange = (e, index) => {
    const newSelectedElements = [...selectedElements];
    newSelectedElements[index][`${e.target.name}`] = e.target.checked === true ? 1 : e.target.checked === false ? 0 : null;
    setSelectedElements(newSelectedElements);
  }

  const getSearchFilteredOptions = (searchInput, selectableOptions) => {
    const filteredOptions = selectableOptions.filter(option => option.label.toLowerCase().includes(searchInput.toLowerCase()));
    setSearchedOptions(filteredOptions)
  }
  const handleSearchChange = (e) => {
    const searchInput = e.target.value;
    setSearchQuery(searchInput)
    let filteredSelectable = [...selectElements];
    if (selectedElements?.length > 0) {
      filteredSelectable = selectElements.filter(option => !selectedElements.some(item => item.value === option.value));
      getSearchFilteredOptions(searchInput, filteredSelectable);
    } else {
      getSearchFilteredOptions(searchInput, filteredSelectable);
    }
  }

  const onDragEnd = (result) => {
    const { destination, source } = result;
    if (!destination) {
      return;
    }
    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }
    let add;
    let active = searchedOptions;
    let complete = selectedElements;
    // Source Logic
    if (source.droppableId === "transactions") {
      add = active[source.index];
      active.splice(source.index, 1);
    } else {
      add = complete[source.index];
      complete.splice(source.index, 1);
    }
    // Destination Logic
    if (destination.droppableId === "transactions") {
      active.splice(destination.index, 0, add);
    } else {
      complete.splice(destination.index, 0, add);
    }
    setSearchedOptions(active)
    const sortedList = complete.map((selectedItem, index) => {
      selectedItem["sortOrder"] = index + 1;
      return selectedItem;
    })
    setSelectedElements(sortedList)
  }

  const scrollToBottom = () => {
    scrollToBottomRef.current.scrollIntoView({ behavior: "smooth" })
  }

  useEffect(() => {
    if (selectElements?.length > 0) {
      setSearchedOptions(selectElements);
    }
  }, [selectElements])

  useEffect(() => {
    if (selectedElements?.length > 7) {
      scrollToBottom()
    }
  }, [selectedElements]);

  return (
    <DragDropContext onDragEnd={onDragEnd} >
      <div className="dnd-container" >
        <Droppable droppableId="transactions">
          {(provided, snapshot) => (
            <div
              className="items-wrapper"
              ref={provided.innerRef}
              {...provided.droppableProps}
            >
              <span className="heading">Transactions</span>
              <div className={`dnd-items ${snapshot.isDraggingOver ? "dnd-ondrag" : ""}`}>
                <input type="text"
                  placeholder="Search..."
                  className="dnd-search-input"
                  onChange={handleSearchChange}
                  value={searchQuery}
                />

                {searchedOptions?.length > 0 &&
                  searchedOptions.map((item, index) => (
                    <Draggable
                      key={item.label}
                      draggableId={item.label}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <div
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          ref={provided.innerRef}
                          className={`drag-item selectable-list ${snapshot.isDragging ? "grabbing" : ""}`}
                          style={{
                            ...provided.draggableProps.style,
                            cursor: snapshot.isDragging ? "grabbing" : "grab",
                          }}
                        >
                          {item.label}
                        </div>
                      )}
                    </Draggable>
                  ))}
                {provided.placeholder}
              </div>
            </div>
          )}
        </Droppable>

        <Droppable droppableId="transactions2" >
          {(provided, snapshot) => (
            <div className="items-wrapper" ref={provided.innerRef}{...provided.droppableProps} >
              <span className="heading" >Selected Transactions</span>
              <div className={`dnd-items ${snapshot.isDraggingOver ? "dnd-ondrag" : ""} ${selectedElements?.length > 0 ? "selected-list" : ""}`} >
                {selectedElements?.length > 0 && <Row className="selected-row" >
                  <Col md="3" className="mb-3"><div className="selected-header" >Sort Order</div></Col>
                  <Col md="4" className="mb-4"><div className="selected-header-left" >Transaction</div> </Col>
                  <Col md="3" className="mb-3"><div className="selected-header" >Is Mandatory</div></Col>
                  <Col md="2" className="mb-2"><div className="selected-header" >Is Sync</div></Col>
                </Row>}
                {selectedElements?.length > 0 &&
                  selectedElements.map((item, index) => (
                    <Draggable
                      key={item.label}
                      draggableId={item.label}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <div
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          ref={provided.innerRef}
                          className={`drag-item ${snapshot.isDragging ? "grabbing" : ""}`}
                          style={{
                            ...provided.draggableProps.style,
                            cursor: snapshot.isDragging ? "grabbing" : "grab",
                          }}
                        >
                          <Row className="selected-row" >
                            <Col md="3" className="mb-3 selected-column" >
                              <div className="center-items">{item.sortOrder}</div>
                            </Col>
                            <Col md="4" className="mb-4">
                              <div className="" >{item.label}</div>
                            </Col>
                            <Col md="3" className="mb-3" >
                              <div className="center-items" ><input type="checkbox" checked={item.isMandatory} name="isMandatory" onChange={(e) => handleCheckboxChange(e, index)} /></div>
                            </Col>
                            <Col md="2" className="mb-2" >
                              <div className="center-items" >
                                <input type="checkbox" checked={item.isSync} name="isSync" onChange={(e) => handleCheckboxChange(e, index)} />
                              </div>
                            </Col>
                          </Row>
                        </div>
                      )}
                    </Draggable>
                  ))}
                {provided.placeholder}
                <div ref={scrollToBottomRef} />
              </div>
            </div>
          )}
        </Droppable>
      </div>
    </DragDropContext>
  )
};

export default DragAndDrop;
